<template>
    <div class="pt-8"
         v-if="rams.sendLog.filter(e => (e.action && (e.action.type==='Approval Request') && (e.status!=='Revoked'))).length">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Approval Requests Sent to</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm">
            <div class="flex w-full py-1"
                 v-for="(sendRequest) in rams.sendLog.filter(e => (e.action && (e.action.type==='Approval Request') && (e.status!=='Revoked')))"
            >
                <div class="flex-1 truncate" v-text="sendRequest.handle">
                </div>
                <div class="" v-if="sendRequest.viewedAt">
                    <i class="fas fa-eye text-green-400 mt-1.5" style="font-size: 10px;"></i>
                </div>
                <div class="" v-else>
                    <i class="fas fa-eye-slash text-gray-500 mt-1.5" style="font-size: 10px;"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {RAMS} from "../../../models";

export default {
    components: {},
    props: {
        rams: RAMS,
    },
    data() {
        return {}
    },
    methods: {
        getStatus() {
        },
    },
    mounted() {
    },
}
</script>
